import { Module } from 'vuex';
import { IRootState } from '@/store';
import { ISalesRepState } from './sales-rep.types';
import { IUserData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: ISalesRepState = {
  version: 1,
  salesReps: [] as IUserData[]
};

const namespaced = true;

export const salesRep: Module<ISalesRepState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
